import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {SettingsReferenceEnum} from '../../../../settings-new/models';
import {_DEFAULT_USER_ACCESS_USER_TABLE_SETTINGS, IUserAccessUserTableSettings} from '../access';
import {IUserAccessFeature} from '../user-access-features';

//#region INTERFACE IFeatureUserTable
export interface IFeatureUserTable extends IUserAccessFeature, Object {
  crudAccess: IUserAccessUserTableSettings;
}

//#endregion

//#region CONST _FEATURE_USER_PROFILE_DEFAULT
export const _FEATURE_USER_TABLE_SETTINGS_DEFAULT: Readonly<IFeatureUserTable & Object> = {
  displayText: NavigationPageEnumHumanReadable.TableSettings,
  feature: NavigationPageEnum.TableSettings,
  ref: SettingsReferenceEnum.applicationUserTableSettings,
  standalone: true,
  crudAccess: {
    ..._DEFAULT_USER_ACCESS_USER_TABLE_SETTINGS,
  },
};
//#endregion
